import React from 'react';
import { IoLogoGithub } from "react-icons/io";
import { SiSpigotmc } from "react-icons/si";
import { FaSquareXTwitter } from "react-icons/fa6";
import MinecraftDoll from "./ui/MinecraftDoll";

const Hero = () => {
  return (
    <div
      id="about"
      className="relative min-h-screen flex items-center justify-center px-4 sm:px-6 lg:px-8 py-28 bg-[#121212] border-b-4 border-black select-none"
      style={{
        backgroundImage: 'radial-gradient(circle, rgba(0,0,0,0) 0%, rgba(0,0,0,0.5) 100%), url("data:image/svg+xml;utf8,<svg xmlns=\'http://www.w3.org/2000/svg\' width=\'16\' height=\'16\' viewBox=\'0 0 16 16\'><rect width=\'16\' height=\'16\' fill=\'%231a1a1a\'/><rect x=\'0\' y=\'0\' width=\'8\' height=\'8\' fill=\'%23161616\'/><rect x=\'8\' y=\'8\' width=\'8\' height=\'8\' fill=\'%23161616\'/><rect x=\'0\' y=\'0\' width=\'16\' height=\'16\' fill=\'none\' stroke=\'%23111111\' stroke-width=\'1\'/></svg>")',
        backgroundRepeat: 'repeat',
        imageRendering: 'pixelated'
      }}
    >
      <div className="relative z-10 w-full max-w-5xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        
        {/* Left Column (Bio & Social buttons) */}
        <div className="space-y-8 text-center lg:text-left lg:col-span-7">
          <div className="space-y-4">
            
            {/* Minecraft Title Style logo */}
            <div className="relative inline-block">
              <h1 
                className="font-sans text-2xl sm:text-3xl md:text-4xl lg:text-[42px] font-extrabold uppercase tracking-wide text-[#ffff55] leading-none"
                style={{
                  textShadow: '3px 3px 0px #3f3f00, 4px 4px 0px #000000',
                  fontFamily: "'Press Start 2P', sans-serif"
                }}
              >
                IamTheDefender
              </h1>
              {/* Slanted pulsing splash text */}
              <div 
                className="absolute -top-5 -right-6 md:-right-12 bg-[#ffff55] text-black border-2 border-black px-2 py-0.5 text-[10px] md:text-xs font-bold uppercase tracking-wider origin-center rotate-[-15deg] scale-100 animate-pulse"
                style={{
                  boxShadow: '2px 2px 0px #000000',
                  textShadow: 'none',
                  animation: 'pulse 1s infinite alternate'
                }}
              >
                Plugins!
              </div>
            </div>

            <h2 className="text-xl sm:text-2xl font-bold text-[#55ff55] tracking-widest font-mono">
              &gt; Java Developer
            </h2>
          </div>
          
          <div className="max-w-2xl mx-auto lg:mx-0 bg-[#2e2e2e]/90 p-4 border-2 border-black shadow-[inset_-2px_-2px_0px_0px_#1a1a1a,inset_2px_2px_0px_0px_#5a5a5a]">
            <p className="text-lg sm:text-xl text-[#aaaaaa] leading-relaxed font-mono">
              I'm a Java Developer mostly focused on creation of add-ons and plugins for Minecraft. I have expertise in Plugin development with various API's such as SpigotMC, PaperMC, Bungeecord, Velocity, Folia or more of their forks. I am a very passionate developer and give my best to every project.
            </p>
          </div>
          
          {/* Social Links as Minecraft buttons */}
          <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 pt-2">
            <a
              className="mc-btn flex items-center gap-2"
              href="https://github.com/IamTheDefender"
              target="_blank"
              rel="noopener noreferrer"
            >
              <IoLogoGithub className="text-xl" />
              <span>GitHub</span>
            </a>
            
            <a
              className="mc-btn flex items-center gap-2"
              href="https://twitter.com/iamthedefender_"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaSquareXTwitter className="text-xl" />
              <span>Twitter</span>
            </a>
            
            <a
              className="mc-btn flex items-center gap-2 !text-[#ff5555]"
              href="https://www.spigotmc.org/members/kepler121.1531997/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <SiSpigotmc className="text-xl" />
              <span>SpigotMC</span>
            </a>

            <a
              className="mc-btn flex items-center gap-2 !text-[#ffaa00]"
              href="/terms.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span>Terms of Service</span>
            </a>
          </div>
        </div>

        {/* Right Column (Pedestal + 3D Minecraft player skin) */}
        <div className="lg:col-span-5 w-full flex flex-col items-center justify-center">
          <div className="mc-panel p-4 rounded-none shadow-2xl relative bg-[#2e2e2e]/40 flex items-center justify-center border-4 border-black">
            <MinecraftDoll />
          </div>
        </div>

      </div>
    </div>
  );
};

export default Hero;